export const LIST_CUSTOMER_PAYMENT_METHODS_REQUEST = 'LIST_CUSTOMER_PAYMENT_METHODS_REQUEST';
export const LIST_CUSTOMER_PAYMENT_METHODS_SUCCESS = 'LIST_CUSTOMER_PAYMENT_METHODS_SUCCESS';
export const LIST_CUSTOMER_PAYMENT_METHODS_FAILURE = 'LIST_CUSTOMER_PAYMENT_METHODS_FAILURE';
export const CLEAR_CUSTOMER_PAYMENT_METHODS = 'CLEAR_CUSTOMER_PAYMENT_METHODS';
